import { Store } from '@ngrx/store';
import { IButtonSelectItem } from '../../../store/models/button.model';
import { Button } from 'app/store/models/button.model';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { IReducers } from 'app/store/reducers';
import { openDialog } from 'app/store/actions/page.action';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-button-select',
  templateUrl: './button-select.component.html',
  styleUrls: ['./button-select.component.scss'],
})
export class ButtonSelectComponent implements OnInit, OnDestroy {
  @Input() buttonProperties: Button;

  @Input() items: IButtonSelectItem[];

  @Output() selection;

  @Input() attachToBody = false;

  showItems: boolean;

  buttonIcon = faChevronDown;

  @ViewChild('buttonRef', { static: true }) buttonRef: ElementRef;
  @ViewChild('itemsElement', { static: false }) itemsElement: ElementRef<HTMLElement>;

  private positionFixInterval;
  private offsetChanged: boolean;

  constructor(private store: Store<IReducers>) {
  }

  itemClicked(item: IButtonSelectItem) {
    this.toggleItems();

    if (item.onClick) {
      item.onClick();
      return;
    }

    if (this.selection instanceof EventEmitter) {
      this.selection.emit(item.value);
    } else if (this.selection instanceof Function) {
      this.selection(item);
    }
  }

  toggleItems = () => {
    this.showItems = !this.showItems;
    if (!this.showItems) {
      this.offsetChanged = false;
    }
    this.toggleChevron();
    this.removeBodyElement();
  };

  ngOnInit() {
    const dialogComponent = document.querySelector('.Dialog');
    const layoutPage = document.querySelector('.AuthenticatedLayout-container');

    if (dialogComponent) {
      this.attachToBody = true;
    }
    this.positionFixInterval = setInterval(() => {
      if (!this.showItems || this.offsetChanged) {
        return;
      }

      const elementRect = this.itemsElement.nativeElement.getBoundingClientRect();
      const windowRect = document.body.getBoundingClientRect();
      const layoutRect = layoutPage.getBoundingClientRect();

      if (elementRect.left + elementRect.width > windowRect.right) {
        this.itemsElement.nativeElement.style.right = '0px';
      }


      if (this.attachToBody) {
        const createdElement: HTMLElement = document.body.querySelector('#button-items-select');

        if (!createdElement) {
          const element = document.createElement('div');
          element.id = 'button-items-select';
          element.classList.add('ButtonSelect');
          element.append(this.itemsElement.nativeElement);
          element.style.position = 'absolute';
          let offsetToSet = this.buttonRef.nativeElement.offsetTop;
          if (elementRect.height + this.buttonRef.nativeElement.offsetTop > layoutRect.height) {
            offsetToSet -= elementRect.height;
            this.offsetChanged = true;
          }
          element.style.top = (offsetToSet) + 'px';
          element.style.left = (this.buttonRef.nativeElement.offsetLeft) + 'px';
          element.style.zIndex = '1051';
          document.body.appendChild(element);
        } else {
          createdElement.style.top = (this.buttonRef.nativeElement.offsetTop) + 'px';
          createdElement.style.left = (this.buttonRef.nativeElement.offsetLeft) + 'px';
        }
      }

      // if (this.staticPosition) {
      //   this.itemsElement.nativeElement.style.position = 'static';
      // }
    }, 500);
  }

  openDialog(item: IButtonSelectItem): void {
    if (item.dialogContent) {
      this.store.dispatch(openDialog({ dialogData: item.dialogContent }));
    }
  }

  @HostListener('window:mousemove', ['$event'])
  public trackMouseMove($event: MouseEvent) {
    if (!this.attachToBody || !this.showItems) {
      return;
    }

    const targetElement = document.getElementById('button-items-select');
    if (!targetElement) {
      return;
    }

    if (!targetElement.matches(':hover') && !this.buttonRef.nativeElement.matches(':hover')) {
      this.toggleItems();
    }
  }

  @HostListener('mouseleave')
  public hideItems(): void {
    if (!this.attachToBody && this.showItems === true) {
      this.removeBodyElement();
      this.showItems = false;
      this.offsetChanged = false;
      this.buttonIcon = faChevronDown;
    }
  }

  removeBodyElement() {
    if (this.attachToBody) {
      const targetElement = document.body.querySelector('#button-items-select');

      if (targetElement) {
        targetElement.remove();
      }
    }
  }

  // -------------------------------------------------------------------------
  // Event listeners
  // -------------------------------------------------------------------------

  getTopPosition() {
    const rect: DOMRect = this.buttonRef.nativeElement.getBoundingClientRect();

    return `${rect.top + 40}px`;
  }

  getLeftPosition() {
    if (!this.itemsElement) {
      return;
    }
    const rect: DOMRect = this.buttonRef.nativeElement.getBoundingClientRect();
    const itemsRect: DOMRect =
      this.itemsElement.nativeElement.getBoundingClientRect();

    return `${rect.left + itemsRect.width}px`;
  }

  onMouseOverElement(event: Event, item: IButtonSelectItem) {
    if (item.children && item.children.length) {
      const target = event.target;

      if (target) {
        const children: Element[] = target['children'];
        if (children.length > 0) {
          for (const c of children) {
            if (c.classList.contains('wrapper')) {
              const wrapperRect = c.getBoundingClientRect();
              const authenticatedLayoutContainer = document.getElementById('AuthenticatedLayoutContainer');

              if (authenticatedLayoutContainer) {
                const authenticatedLCRect = authenticatedLayoutContainer.getBoundingClientRect();

                if (wrapperRect.right > authenticatedLCRect.right) {
                  // now need to patch the children to go on the right side

                  c.classList.add('on-left');
                }
              }
              break;
            }
          }
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.positionFixInterval) {
      clearInterval(this.positionFixInterval);
    }
  }

  private toggleChevron() {
    this.buttonIcon = this.showItems ? faChevronUp : faChevronDown;
  }
}
